module.exports = "/images/xTech.png?ff40375374b6a335e12a93d966b1ee7c";